import React from "react";
import styles from "./skills.module.scss";

export default function Skills() {
  return (
    <>
      <div className={styles.page}>
        <div className={styles.planets_container}>
          <div className={styles.sun}>skills</div>

          <div
            className={styles.aries_planet_z_index}
            id={styles.first_planet_z_index}
          >
            <div className={styles.route} id={styles.aries_route}>
              <div
                className={styles.aries_planet_container}
                id={styles.first_planet_container}
              >
                <div className={styles.first_planet} id={styles.aries_planet}>
                  CSS
                  <div className={styles.crater}></div>
                  <div className={styles.smallCrater}></div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={styles.aries_planet_z_index}
            id={styles.second_planet_z_index}
          >
            <div className={styles.route} id={styles.aries_route}>
              <div
                className={styles.aries_planet_container}
                id={styles.second_planet_container}
              >
                <div className={styles.second_planet} id={styles.aries_planet}>
                  REST API
                  <div className={styles.crater}></div>
                  <div className={styles.smallCrater}></div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={styles.aries_planet_z_index}
            id={styles.third_planet_z_index}
          >
            <div className={styles.route} id={styles.aries_route}>
              <div
                className={styles.aries_planet_container}
                id={styles.third_planet_container}
              >
                <div className={styles.ringFront} id={styles.red}></div>
                <div className={styles.ringBack} id={styles.red}></div>
                <div className={styles.third_planet} id={styles.aries_planet}>
                  HTML
                  <div className={styles.crater}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.planets_container} id={styles.secondAxisPlanets}>
          <div
            className={styles.ursaMinor_planet_z_index}
            id={styles.first_planet_z_index}
          >
            <div className={styles.route} id={styles.ursaMinor_route}>
              <div
                className={styles.ursaMinor_planet_container}
                id={styles.first_planet_container}
              >
                <div
                  className={styles.third_planet}
                  id={styles.ursaMinor_planet}
                >
                  JS
                  <div className={styles.crater}></div>
                  <div className={styles.smallCrater}></div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={styles.ursaMinor_planet_z_index}
            id={styles.second_planet_z_index}
          >
            <div className={styles.route} id={styles.ursaMinor_route}>
              <div
                className={styles.ursaMinor_planet_container}
                id={styles.second_planet_container}
              >
                <div className={styles.ringFront}></div>
                <div className={styles.ringBack}></div>
                <div
                  className={styles.first_planet}
                  id={styles.ursaMinor_planet}
                >
                  React
                  <div className={styles.crater}></div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={styles.ursaMinor_planet_z_index}
            id={styles.third_planet_z_index}
          >
            <div className={styles.route} id={styles.ursaMinor_route}>
              <div
                className={styles.ursaMinor_planet_container}
                id={styles.third_planet_container}
              >
                <div
                  className={styles.second_planet}
                  id={styles.ursaMinor_planet}
                >
                  Python
                  <div className={styles.crater}></div>
                  <div className={styles.smallCrater}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.planets_container} id={styles.thirdAxisPlanets}>
          <div
            className={styles.ursaMajor_planet_z_index}
            id={styles.first_planet_z_index}
          >
            <div className={styles.route} id={styles.ursaMajor_route}>
              <div
                className={styles.ursaMajor_planet_container}
                id={styles.first_planet_container}
              >
                <div
                  className={styles.second_planet}
                  id={styles.ursaMajor_planet}
                >
                  Fire Base<div className={styles.crater}></div>
                  <div className={styles.smallCrater}></div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={styles.ursaMajor_planet_z_index}
            id={styles.second_planet_z_index}
          >
            <div className={styles.route} id={styles.ursaMajor_route}>
              <div
                className={styles.ursaMajor_planet_container}
                id={styles.second_planet_container}
              >
                <div className={styles.ringFront} id={styles.orange}></div>
                <div className={styles.ringBack} id={styles.orange}></div>
                <div
                  className={styles.third_planet}
                  id={styles.ursaMajor_planet}
                >
                  .NET
                  <div className={styles.crater}></div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={styles.ursaMajor_planet_z_index}
            id={styles.third_planet_z_index}
          >
            <div className={styles.route} id={styles.ursaMajor_route}>
              <div
                className={styles.ursaMajor_planet_container}
                id={styles.third_planet_container}
              >
                <div
                  className={styles.first_planet}
                  id={styles.ursaMajor_planet}
                >
                  TS
                  <div className={styles.crater}></div>
                  <div className={styles.smallCrater}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
